/*global jQuery, STUDIP */
STUDIP.domReady(() => {
    STUDIP.Avatar.init('#avatar-upload');
});
